@if (user) {
    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'roles.roleGroupsTitle' | t }}</div>
        <div class="detail-page-card-actions">
            <ng-select
                data-uiid="usermanagement-roles-rolegroups"
                id="roleGroupsSelect"
                name="roleGroupsSelect"
                [items]="sd.roleGroups"
                [(ngModel)]="user.roleGroups"
                bindLabel="name"
                bindValue="ID"
                [disabled]="!permissions.canAssignGroups"
                [multiple]="true"
                [clearable]="true"
                [loading]="!sd.roleGroups"
                [closeOnSelect]="false"
                (change)="roleGroupChanged()"
            >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div>
                        <b>{{ item.name }}</b>
                        @if (item.description) {
                            <small class="text-muted"> - {{ item.description }}</small>
                        }
                    </div>
                </ng-template>
            </ng-select>
        </div>
    </div>
}

<role-assign
    data-uiid="usermanagement-roles-roleassign"
    [moduleRoles]="user.moduleRoles"
    [userModel]="user"
    [allowChange]="permissions.canAssignRoles"
    #roleAssign
></role-assign>
